/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobiera listę zakładek należących do aktualnie zalogowanego użytkownika
   * @method
   * @name Api#getZakladki
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.control - Control
   */
  Api.prototype.getZakladki = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zakladki',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }
    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Tworzy zakładkę należącą do aktualnie zalogowanego użytkownika
   * @method
   * @name Api#postZakladki
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.nazwa - nazwa
   * @param {number} parameters.x - x
   * @param {number} parameters.y - y
   * @param {string} parameters.skala - skala
   */
  Api.prototype.postZakladki = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zakladki',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['nazwa'] !== undefined) {
      form['nazwa'] = parameters['nazwa'];
    }

    if (parameters['nazwa'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: nazwa'));
      return deferred.promise;
    }

    if (parameters['x'] !== undefined) {
      form['x'] = parameters['x'];
    }

    if (parameters['x'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: x'));
      return deferred.promise;
    }

    if (parameters['y'] !== undefined) {
      form['y'] = parameters['y'];
    }

    if (parameters['y'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: y'));
      return deferred.promise;
    }

    if (parameters['skala'] !== undefined) {
      form['skala'] = parameters['skala'];
    }

    if (parameters['skala'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: skala'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuwa zakładkę o podanym id należącą do aktualnie zalogowanego użytkownika
   * @method
   * @name Api#deleteZakladkiById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - id
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteZakladkiById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zakladki/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Zastępuje zakładkę o podanym id należącą do aktualnie zalogowanego użytkownika
   * @method
   * @name Api#putZakladkiById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - id
   * @param {string} parameters.token - Token
   * @param {string} parameters.nazwa - nazwa
   * @param {number} parameters.x - x
   * @param {number} parameters.y - y
   * @param {string} parameters.skala - skala
   */
  Api.prototype.putZakladkiById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/zakladki/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['nazwa'] !== undefined) {
      form['nazwa'] = parameters['nazwa'];
    }

    if (parameters['nazwa'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: nazwa'));
      return deferred.promise;
    }

    if (parameters['x'] !== undefined) {
      form['x'] = parameters['x'];
    }

    if (parameters['x'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: x'));
      return deferred.promise;
    }

    if (parameters['y'] !== undefined) {
      form['y'] = parameters['y'];
    }

    if (parameters['y'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: y'));
      return deferred.promise;
    }

    if (parameters['skala'] !== undefined) {
      form['skala'] = parameters['skala'];
    }

    if (parameters['skala'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: skala'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'PUT',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
